module.exports = __webpack_public_path__ + "img/le.77624b86.png";